import React from "react";

const skillsContent = [
  { skillClass: "p92", skillPercent: "92", skillName: "Content Creation" },
  { skillClass: "p95", skillPercent: "95", skillName: "VFX Production" },
  { skillClass: "p89", skillPercent: "89", skillName: "Post-Production Mastery" },
  { skillClass: "p95", skillPercent: "95", skillName: "Client Coordination" },
  { skillClass: "p97", skillPercent: "97", skillName: "Project Management" },
  { skillClass: "p95", skillPercent: "95", skillName: "Product Expertise" },
  { skillClass: "p90", skillPercent: "90", skillName: "Technical Proficiency" },
  { skillClass: "p96", skillPercent: "96", skillName: "Promotion Strategy" },
];

const Ski = () => {
  return (
    <>
      {skillsContent.map((val, i) => (
        <div className="col-6 col-md-3 mb-3 mb-sm-5" key={i}>
          <div className={`c100 ${val.skillClass}`}>
            <span>{val.skillPercent}%</span>
            <div className="slice">
              <div className="bar"></div>
              <div className="fill"></div>
            </div>
          </div>
          <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">
            {val.skillName}
          </h6>
        </div>
      ))}
    </>
  );
};

export default Ski;
